import { render, staticRenderFns } from "./Reu.vue?vue&type=template&id=5bcafc8a&scoped=true&"
import script from "./Reu.vue?vue&type=script&lang=js&"
export * from "./Reu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcafc8a",
  null
  
)

export default component.exports